module.exports = __webpack_public_path__ + "img/mech_lion 1.5b99e03f.jpg";